import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AutoComplete, Spin } from "antd";
import { searchForGroup } from "../../actions";
import { getGroups } from "../../selectors";

class GroupSearch extends React.Component {
  static propTypes = {
    groups: PropTypes.arrayOf(PropTypes.object),
    handleResultSelect: PropTypes.func.isRequired,
    isEditingMembership: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string,
    ]),
    searchForGroup: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    isEditingMembership: false,
  };

  state = {
    value: "",
    loading: false,
    options: [],
  };

  debounceTimeout = null;

  reset = () => {
    this.setState({ options: [], loading: false });
  };

  isEditing = () =>
    this.props.isEditingMembership === true ||
    this.props.isEditingMembership === "true";

  formatOptions = (groups) =>
    groups
      // hide "Slave"/Replica groups if editing the application's membership
      // because applications can only be added to GMS groups
      .filter((g) => g.syncType !== "Slave" || !this.isEditing())
      .map((g) => ({
        label: `${g.groupIdentifier} (${g.displayName})`,
        value: g.groupIdentifier,
        group: g,
      }));

  handleSelect = (_value, option) => {
    if (option?.group) {
      this.props.handleResultSelect(option);
      this.setState({ value: "", options: [] });
    }
  };

  handleSearch = (value) => {
    this.setState({ value });
    if (value.length <= 2) return this.reset();

    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => {
      this.fetchOptions(value);
    }, 500);
  };

  fetchOptions = async (query) => {
    this.setState({ loading: true });
    try {
      const { payload } = await this.props.searchForGroup({
        filter: `groupIdentifier:contains:${query.trim()}`,
        sort: "groupIdentifier",
        limit: 100,
      });
      this.setState({
        options: this.formatOptions(payload?.data || []),
        loading: false,
      });
    } catch (err) {
      console.error("Group search failed", err);
      this.setState({ loading: false });
    }
  };

  render() {
    const { value, options, loading } = this.state;
    const { className } = this.props;

    return (
      <AutoComplete
        className={className}
        options={options}
        value={value}
        placeholder="Search groups..."
        loading={loading}
        onSearch={this.handleSearch}
        onSelect={this.handleSelect}
        style={{ width: "100%" }}
        notFoundContent={loading ? <Spin size="small" /> : "No matching groups"}
        filterOption={false}
      />
    );
  }
}

export default connect(
  (state) => ({
    groups: getGroups(state),
  }),
  { searchForGroup },
)(GroupSearch);
